import React from 'react';
import { LinkOutlined } from '@ant-design/icons';
import githubPng from '../../styles/images/github.png';
import figmaPng from '../../styles/images/figma.png';
import zhihuPng from '../../styles/images/zhihu.png';
import rednotePng from '../../styles/images/rednote.png';
import tiktokPng from '../../styles/images/tiktok.png';
import officalAccountPng from '../../styles/images/offical_account.png';
import bilibiliPng from '../../styles/images/bilibili.png';
import jikePng from '../../styles/images/jike.png';
import customPng from '../../styles/images/custom.png';
import wechatPng from '../../styles/images/wechat.png';
import weiboPng from '../../styles/images/weibo.png';
import shareLinkIcon from '../../assets/shareLink.svg';
import { SOCIAL_ICON_MAP } from '../../utils/constants';
import { useEmbeddedAuth } from '../../contexts/EmbeddedAuthContext';
import { getCurrentUser } from '../../services/authService';

function SocialCard({ media, link, label, onCardClick }) {
  const iconKey = SOCIAL_ICON_MAP[media?.toLowerCase?.()] || 'custom';
  const { showLoginModal } = useEmbeddedAuth();
  const currentUser = getCurrentUser();
  let icon = null;
  let text = '';

  switch (iconKey) {
    case 'wechat':
      icon = <img src={wechatPng} alt="微信" className="w-8 h-8" />;
      text = '加好友';
      break;
    case 'weibo':
      icon = <img src={weiboPng} alt="微博" className="w-8 h-8" />;
      text = '关注';
      break;
    case 'figma':
      icon = <img src={figmaPng} alt="Figma" className="w-8 h-8" />;
      text = '关注';
      break;
    case 'zhihu':
      icon = <img src={zhihuPng} alt="知乎" className="w-8 h-8" />;
      text = '关注';
      break;
    case 'rednote':
      icon = <img src={rednotePng} alt="小红书" className="w-8 h-8" />;
      text = '关注';
      break;
    case 'github':
      icon = <img src={githubPng} alt="GitHub" className="w-8 h-8" />;
      text = '关注';
      break;
    case 'tiktok':
      icon = <img src={tiktokPng} alt="抖音" className="w-8 h-8" />;
      text = '关注';
      break;
    case 'offical_account':
      icon = <img src={officalAccountPng} alt="公众号" className="w-8 h-8" />;
      text = '关注';
      break;
    case 'bilibili':
      icon = <img src={bilibiliPng} alt="Bilibili" className="w-8 h-8" />;
      text = '关注';
      break;
    case 'jike':
      icon = <img src={jikePng} alt="即刻" className="w-8 h-8" />;
      text = '关注';
      break;
    case 'custom':
      icon = <img src={customPng} alt="自定义" className="w-8 h-8" />;
      text = <img src={shareLinkIcon} alt="分享" className="w-4 h-4" />;
      break;
    default:
      icon = <LinkOutlined className="text-3xl text-gray-500" />;
      text = <img src={shareLinkIcon} alt="分享" className="w-4 h-4" />;
  }

  const handleClick = (e) => {
    e.preventDefault();
    if (!currentUser) {
      showLoginModal();
      return;
    }
    if (onCardClick) {
      onCardClick(iconKey, link, label);
    }
  };

  return (
    <div
      onClick={handleClick}
      className="flex flex-col items-center justify-center bg-white rounded-2xl shadow p-4 h-40 w-full border border-gray-100 hover:shadow-md transition-all cursor-pointer min-h-[120px]"
    >
      <div className="mb-2">{icon}</div>
      <div className="text-base font-medium text-gray-900">{label}</div>
      <div className="bg-[var(--color-primary)] text-black rounded-full py-1 text-sm font-medium border-none mt-4 px-8">
        {text}
      </div>
    </div>
  );
}

export default SocialCard;
